module.exports = __webpack_public_path__ + "static/img/rouPic.71323878.png";